import { render, staticRenderFns } from "./DefinitionContent.vue?vue&type=template&id=79224bc8"
import script from "./DefinitionContent.vue?vue&type=script&lang=js"
export * from "./DefinitionContent.vue?vue&type=script&lang=js"
import style0 from "./DefinitionContent.vue?vue&type=style&index=0&id=79224bc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports